module.exports = __webpack_public_path__ + "img/description-image.68885746.jpg";